module.exports['gopher_parsedir'] = require('./gopher_parsedir')
